import { propOr, omit, mapObjIndexed } from 'ramda'

const flattenFirstRootTranslation = obj => {
  const translations = propOr([], 'translations', obj)

  return {
    ...translations[0],
    ...omit(['translations'], obj)
  }
}

// TODO: tailcall optimization?
const flattenFirstTranslations = obj => {
  if (Array.isArray(obj)) {
    return obj.map(o => flattenFirstTranslations(o))
  }

  const flattened = flattenFirstRootTranslation(obj)

  return mapObjIndexed((val, key) => {
    if (Array.isArray(val)) {
      return val.map(o => flattenFirstTranslations(o))
    }

    if (val !== null && typeof val === 'object') {
      if (key === 'table') {
        // do not modify table content
        return val
      }
      return flattenFirstTranslations(val)
    }

    return val
  }, flattened)
}

export default flattenFirstTranslations



// WEBPACK FOOTER //
// ./src/utils/flattenFirstTranslations.js